export const SUPPORTED_SLUGS = [
  'en', 'zh-hant', 'zh-hans',
  'ja', 'ko', 'th', 'vi', 'id',
  'es', 'fr', 'de', 'pt', 'it', 'ru', 'tr', 'nl',
  'ar', 'hi', 'ms', 'pl',
] as const;
export type LocaleSlug = (typeof SUPPORTED_SLUGS)[number];

export const slugToLocale: Record<LocaleSlug, string> = {
  'en': 'en_US',
  'zh-hant': 'zh_TW',
  'zh-hans': 'zh_CN',
  'ja': 'ja',
  'ko': 'ko',
  'th': 'th',
  'vi': 'vi',
  'id': 'id',
  'es': 'es',
  'fr': 'fr',
  'de': 'de',
  'pt': 'pt',
  'it': 'it',
  'ru': 'ru',
  'tr': 'tr',
  'nl': 'nl',
  'ar': 'ar',
  'hi': 'hi',
  'ms': 'ms',
  'pl': 'pl',
};

export const localeToSlug: Record<string, LocaleSlug> = {
  'en_US': 'en',
  'zh_TW': 'zh-hant',
  'zh_CN': 'zh-hans',
  'ja': 'ja',
  'ko': 'ko',
  'th': 'th',
  'vi': 'vi',
  'id': 'id',
  'es': 'es',
  'fr': 'fr',
  'de': 'de',
  'pt': 'pt',
  'it': 'it',
  'ru': 'ru',
  'tr': 'tr',
  'nl': 'nl',
  'ar': 'ar',
  'hi': 'hi',
  'ms': 'ms',
  'pl': 'pl',
};

export const slugToHreflang: Record<LocaleSlug, string> = {
  'en': 'en',
  'zh-hant': 'zh-Hant',
  'zh-hans': 'zh-Hans',
  'ja': 'ja',
  'ko': 'ko',
  'th': 'th',
  'vi': 'vi',
  'id': 'id',
  'es': 'es',
  'fr': 'fr',
  'de': 'de',
  'pt': 'pt',
  'it': 'it',
  'ru': 'ru',
  'tr': 'tr',
  'nl': 'nl',
  'ar': 'ar',
  'hi': 'hi',
  'ms': 'ms',
  'pl': 'pl',
};

export const DEFAULT_SLUG: LocaleSlug = 'en';

export function getSlugFromPath(path: string): LocaleSlug | null {
  const segments = path.split('/').filter(Boolean);
  const first = segments[0]?.toLowerCase();
  if (first && (SUPPORTED_SLUGS as readonly string[]).includes(first)) {
    return first as LocaleSlug;
  }
  return null;
}

export function stripLocaleFromPath(path: string): string {
  const slug = getSlugFromPath(path);
  if (!slug) return path;
  const segments = path.split('/').filter(Boolean);
  segments.shift();
  return '/' + segments.join('/');
}

export function buildLocalePath(slug: LocaleSlug, path: string): string {
  const clean = path.startsWith('/') ? path : '/' + path;
  return '/' + slug + (clean === '/' ? '/' : clean);
}

export function detectBrowserSlug(): LocaleSlug {
  const lang = (navigator.language || '').toLowerCase();
  if (lang.indexOf('zh') === 0) {
    if (lang.indexOf('hans') >= 0 || lang === 'zh-cn') return 'zh-hans';
    return 'zh-hant';
  }
  const prefix = lang.split('-')[0];
  const match = SUPPORTED_SLUGS.find(s => s === prefix);
  if (match) return match;
  return 'en';
}
